import './i18n'
import './styles/index.css'

import { createRoot } from 'react-dom/client'
import { Buffer } from 'buffer'

import App from './App.tsx'
import Providers from './providers'

if (!window.Buffer) window.Buffer = Buffer

// ;(function () {
//   if (
//     window.location.origin !== 'https://test.terminus.bet'
//     && !/eruda=true/.test(window.location.search)
//     && localStorage.getItem('active-eruda') != 'true'
//   ) return;
//   document.write(`<script src="//cdn.jsdelivr.net/npm/eruda"><\/script>`);
//   document.write(`<script>window.eruda?.init();<\/script>`);
// })();

createRoot(document.getElementById('root')!).render(
  <Providers>
    <App />
  </Providers>
)
